module.exports = __webpack_public_path__ + "static/media/search-circle.af9421c3.svg";